export default "__VITE_ASSET__CTBDh2Aj__"